import {
  UserDocumentVersion,
  UserDocumentVersionJSON,
} from "./UserDocumentVersion";

export type UserDocumentJSON = {
  id: number;
  document_type_id?: number;
  notes?: string;
  user_id?: number;
  estate_id?: number;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string;
  version?: UserDocumentVersionJSON;
  versions?: UserDocumentVersionJSON[];
  cloud_url?: string;
};

export class UserDocument {
  static path = "documents";
  constructor(
    public id?: number,
    public documentTypeId?: number,
    public notes?: string,
    public userId?: number,
    public estateId?: number,
    public createdAt?: string,
    public updatedAt?: string,
    public deletedAt?: string,
    public version?: UserDocumentVersion,
    public versions?: UserDocumentVersion[],
  ) { }

  static fromJSON = (json: UserDocumentJSON): UserDocument => {
    return new UserDocument(
      json.id,
      json.document_type_id,
      json.notes,
      json.user_id,
      json.estate_id,
      json.created_at,
      json.updated_at,
      json.deleted_at,
      UserDocumentVersion.fromJSON(json?.version),
      json?.versions?.map((versionJson?: UserDocumentVersionJSON) =>
        UserDocumentVersion.fromJSON(versionJson)
      ),
    );
  };

  clone = (): UserDocument => {
    return new UserDocument(
      this.id,
      this.documentTypeId,
      this.notes,
      this.userId,
      this.estateId,
      this.createdAt,
      this.updatedAt,
      this.deletedAt,
      this.version,
      this.versions,
    );
  };

  get newestVersion(): UserDocumentVersion | undefined {
    return this.version // There is only actually 1 version right now
  }
}
